import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
	ElementRef,
	SimpleChange,
	booleanAttribute,
	ChangeDetectionStrategy,
} from "@angular/core"
import { TagItemTypes } from "@app/definitions/types"

import {
	AC_COMMON_IMPORTS,
	AcCommonComponent,
} from "../ac-common/ac-common.component"

@Component({
	selector: "app-autocomplete-with-tags",
	imports: [AC_COMMON_IMPORTS],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "../ac-common/ac-common.component.html",
})
export class AutocompleteWithTagsComponent extends AcCommonComponent {
	@Input({ transform: booleanAttribute }) hasPlus: boolean = false
	@Input() item_type: TagItemTypes = "patient"
	@Input() item_id: number = 0
	@Input({ transform: booleanAttribute }) saveMode: boolean = false
	@Input({ transform: booleanAttribute }) isLocationLimited: boolean = false
	@Input() fuzzySearchableClasses: string[] | null = null
	@Input() objs: any[] = []

	ngOnChanges(changes: SimpleChange) {
		if (changes["objs"]) {
			this.chosenObjs = this.objs
		}
	}

	ngOnInit() {
		this.init()
		if (!this.saveMode && !this.isStatic) {
			return
		}

		if (this.item_id) {
			const tagIds = this.store
				.getSiteDataTable("object_to_tags")
				.filter(
					(row) =>
						row.item_type == this.item_type && row.item_id == this.item_id
				)
				.map((row) => row.tag_id)
			if (tagIds?.length) {
				this.chosenObjs = this.store
					.getSiteDataTable("tags")
					.filter((it) => tagIds.includes(it.id))
					.map((obj) => this.getOpt(obj, "tags"))
			}
		}
	}

	async delete(optObj: any) {
		this.chosenObjs = this.chosenObjs.filter(
			(ob) => ob.id != optObj.id || ob.typeClassName != optObj.typeClassName
		)
		this.outputValue()
		this.focus()
		if (!this.saveMode) {
			return
		}

		const objToDel = this.store
			.getSiteDataTable("object_to_tags")
			.find(
				(row) =>
					row.item_type == this.item_type &&
					row.item_id == this.item_id &&
					row.tag_id == optObj.id
			)
		if (!objToDel) {
			return
		}
		//store delete, api delete
		const res: any = await this.apiService.delete_gen_item(
			"object_to_tags",
			objToDel.id
		)
		if (res.success) {
			this.store.delGenItemRow("object_to_tags", objToDel.id)
		} else {
			this.modalService.openToast("delete_failed")
		}
	}
	keyupOtps(strToLower: string) {
		const allowedTagIds = this.isLocationLimited
			? this.store
					.getSiteDataTable("object_to_tags")
					.filter((it) => it?.item_type === "location")
					.map((it) => it.tag_id)
			: []

		const tbls = this.fuzzySearchableClasses || ["tags"]
		let opts: any[] = []
		tbls.forEach((tbl) => {
			opts = [
				...opts,
				...this.store
					.getSiteDataTable(tbl)
					.filter((it) => {
						if (allowedTagIds?.length) {
							return allowedTagIds.includes(it.id)
						}
						return true
					})
					.filter((it) => it.name.toLowerCase().indexOf(strToLower) != -1)
					.map((obj) => this.getOpt(obj, tbl)),
			]
		})
		return opts
	}

	getOpt(opt: any, tbl: string) {
		return { ...opt, typeClassName: tbl }
	}
	optAlreadyInChosen(optObj: any) {
		return this.chosenObjs.find(
			(ob) => ob.id == optObj.id && ob.typeClassName == optObj.typeClassName
		)
	}
	async addOption(optObj: any) {
		this.options = []
		this.inputStr = ""
		this.focus()

		if (this.optAlreadyInChosen(optObj)) {
			return
		}
		this.chosenObjs = [...this.chosenObjs, { ...optObj }]
		this.outputValue()

		if (!this.saveMode) {
			return
		}
		//store add, api add
		const objToSave = {
			item_id: this.item_id,
			item_type: this.item_type,
			tag_id: optObj.id,
		}
		let message = ""
		const res: any = await this.apiService.save_gen_item(
			"object_to_tags",
			objToSave
		)
		if (res.id) {
			this.store.addGenItemRow("object_to_tags", res)
		}
		this.modalService.openToast(res.id ? "saved_successfully" : "save_failed")
	}
}
